import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import type { MessageKey } from 'types/LocaleMessageKey';

import LandingPageCards from '@/app/components/LandingPage/LandingPageCards';
import type { LandingPageCardData } from '@/app/components/LandingPage/LandingPageCards/types';
import SectionHeading from '@/app/components/SectionHeading';

export interface HardwareEducationSectionProps {
  readonly cards: LandingPageCardData[];
  readonly dataCy?: string | undefined;
  readonly heading: MessageKey;
}

const HardwareEducationSection = ({
  cards,
  dataCy,
  heading,
}: HardwareEducationSectionProps) => {
  return (
    <section className="py-10 lg:pt-28 lg:pb-20" data-cy={dataCy}>
      <LayoutGrid className="mb-10 lg:mb-24">
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <SectionHeading
            animated
            content={heading}
            typographyProps={{
              className: 'leading-tighter tracking-tighter md:text-center',
              Element: 'h2',
              variant: 'h2',
              weight: 'light',
            }}
          />
        </GridItem>
      </LayoutGrid>
      <LandingPageCards cards={cards} />
    </section>
  );
};

export default HardwareEducationSection;
